// Descarga de documentos por turno agrupando los turnos en bloques con
// `Turno in [...]` (Firestore limita "in" a 30 valores) en vez de lanzar una
// query por turno. `filtros` debe incluir Tenant y cualquier otro filtro.
export const TURNOS_POR_QUERY = 30;

export async function queryPorTurnos(firestore, coleccion, turnos, filtros = []) {
  const unicos = Array.from(new Set(turnos));
  const bloques = [];
  for (let i = 0; i < unicos.length; i += TURNOS_POR_QUERY) {
    bloques.push(unicos.slice(i, i + TURNOS_POR_QUERY));
  }
  const snapshots = await Promise.all(
    bloques.map((bloque) =>
      firestore.queryBuilder(coleccion, [
        ...filtros,
        firestore.where("Turno", "in", bloque),
      ])
    )
  );
  const docs = [];
  snapshots.forEach((snap) =>
    snap.docs.forEach((doc) => docs.push({ id: doc.ref.id, ...doc.data() }))
  );
  return docs;
}
